export const RELEVANT_RECORDINGS_VALUES = Array.from({ length: 40 }, (_, i) => i + 1); // [1,...,40]
export const ALL_RELEVANCE_VALUES = [0, ...RELEVANT_RECORDINGS_VALUES]; // [0,...,40]
